export const mixin = {
    data(){
        return{
            column: [
                {
                  prop: 'id',
                  label: 'ID',
                },
                {
                  prop: 'title',
                  label: '应用名',
                },
                {
                  prop: 'system',
                  label: '平台',
                },
                {
                  prop: 'bu_app_status',
                  label: '广告中台',
                },
                {
                  prop: 'csj_status',
                  label: '穿山甲',
                },
                {
                  prop: 'gdt_status',
                  label: '广点通',
                },
                {
                  prop: 'ks_status',
                  label: '快手',
                },
                {
                  prop: 'kj_status',
                  label: '铠甲',
                },
                {
                  prop: 'bqt_status',
                  label: '百度',
                },
                {
                  prop: 'ljwh_status',
                  label: '灵机',
                },
                {
                  prop: 'option',
                  label: '操作',
                },
              ],
        }
    }
}